export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="64" height="64" rx="16" fill="#121212" />
    <rect
      x="1.5"
      y="1.5"
      width="61"
      height="61"
      rx="14.5"
      stroke="#D4AF37"
      strokeOpacity="0.55"
      strokeWidth="1.5"
    />
    <circle cx="32" cy="32" r="20" stroke="#D4AF37" strokeWidth="1.4" strokeOpacity="0.8" />
    <text
      x="32"
      y="41"
      textAnchor="middle"
      fontSize="26"
      fill="#D4AF37"
      fontFamily="Georgia, 'Times New Roman', serif"
    >
      ॐ
    </text>
  </svg>
);

export const Logo = ({ compact = false }) => (
  <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
    <LogoMark size={compact ? 34 : 40} />
    <span className="leading-none">
      <span className="block font-display text-lg sm:text-xl font-semibold tracking-wide text-cream group-hover:text-gold transition-colors duration-300">
        Om Sri Sri
      </span>
      <span className="block font-mono text-[10px] tracking-[0.35em] uppercase text-gold/90 mt-1">
        Collection
      </span>
    </span>
  </a>
);
